import React from 'react';
import Nav from '../layouts/Nav';
// import Balance from './balance/Balance';
// import MyAccounts from './accounts/MyAccounts';
// import NextRenewal from './renewal/NextRenewal';
import UsageHistory from './usage-history/UsageHistory';
import Footer from '../layouts/Footer';
import AccountsCard from './accounts/AccountsCard';

const Overview = () => {
  return (
    <div className="container-fluid p-0" id="">
      <Nav />
      <hr className="mt-0 mb-3 d-flex d-md-none" />
      <div className="container" id="page-container">
        <div className="ml-xl-5 row d-flex align-items-center">
          {/* <Balance /> */}
          <div className="ml-xl-4 col-xl-6 col-md-6">
            <AccountsCard
              cardName="My Account(s)"
              btnName="View all"
              image="images/house.png"
            />
            <AccountsCard
              cardName="Next Renewal"
              btnName="Renew"
              image="images/calendar.png"
            />
            {/* <MyAccounts />
            <NextRenewal /> */}
          </div>
          <div className="col-xl-5 col-md-6 align-self-start">
            <UsageHistory />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Overview;
